import React from 'react';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { LookInside } from './components/LookInside';
import { MetaPixel, PIXEL_ID } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { ProblemSolution } from './components/ProblemSolution';
import { ProductShowcase } from './components/ProductShowcase';
import { PurchasePopup } from './components/PurchasePopup';
import { Testimonials } from './components/Testimonials';
import { Volumes } from './components/Volumes';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-navy selection:bg-brand-light selection:text-navy" data-id="element-0" data-mp="28ufpyg1ohml6">
      <MetaPixel data-id="element-1" data-mp="23w4fq47h1a2f" />
      <main data-id="element-2" data-mp="23ujksdh8vp41">
        <Hero data-id="element-3" data-mp="23utb6267bya9" />
        <ProblemSolution data-id="element-4" data-mp="23t8i6gzjcnei" />
        <ProductShowcase data-id="element-5" data-mp="3ik7gwiph6frp" />
        <Volumes data-id="element-6" data-mp="3ikqwvtvkeu33" />
        <LookInside data-id="element-7" data-mp="3ij61y35c994p" />
        <Bonuses data-id="element-8" data-mp="3ihv22ef0kliv" />
        <Differentiators data-id="element-9" data-mp="3mlj9mx3nbh44" />
        <Pricing data-id="element-10" data-mp="3ml17jjuay8oa" />
        <Testimonials data-id="element-11" data-mp="3mkhofzsx1e8o" />
        <Faq data-id="element-12" data-mp="3mjq2zht18ww4" />
        <FinalClose data-id="element-13" data-mp="3mj6ibtbzzuee" />
      </main>
      <Footer data-id="element-14" data-mp="3rbrbcsn2y3gv" />
      <PurchasePopup data-id="element-15" data-mp="3rdapodp6e4g0" />
      <noscript data-id="element-16" data-mp="3rcswxr1q28cu">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-17" data-mp="3recdlirailf5" />
      </noscript>
    </div>;
}